"use client";

import { c as _c } from "react/compiler-runtime";
import posthogClient from "posthog-js";
import { useEffect, useRef } from "react";
import { useSession } from "@domainstack/auth/client";

/**
 * PostHog identity provider that automatically identifies users on login
 * and resets identity on logout.
 *
 * This component should be placed inside the app providers to watch for
 * session changes and keep PostHog identity in sync with auth state.
 */
export function PostHogIdentityProvider(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  const {
    data: session
  } = useSession();
  const previousUserIdRef = useRef(null);
  const userId = session?.user?.id;
  let t1;
  if ($[0] !== session?.user || $[1] !== userId) {
    t1 = () => {
      const currentUserId = userId ?? null;
      const previousUserId = previousUserIdRef.current;
      if (currentUserId && currentUserId !== previousUserId) {
        if (previousUserId) {
          posthogClient.reset();
        }
        const user = session?.user;
        if (user) {
          posthogClient.identify(user.id, {
            email: user.email,
            name: user.name
          }, {
            createdAt: user.createdAt ? new Date(user.createdAt).toISOString() : undefined
          });
        }
      }
      if (!currentUserId && previousUserId) {
        posthogClient.reset();
      }
      previousUserIdRef.current = currentUserId;
    };
    $[0] = session?.user;
    $[1] = userId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = session?.user;
  let t3;
  if ($[3] !== t2 || $[4] !== userId) {
    t3 = [t2, userId];
    $[3] = t2;
    $[4] = userId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t1, t3);
  let t4;
  if ($[6] !== children) {
    t4 = <>{children}</>;
    $[6] = children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}